/**
 * OcorrenciaTrackingCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {OcorrenciaTracking} from '@/model/resource/OcorrenciaTracking'

/* TODO: review generated class */
@HttpExclude()
export class OcorrenciaTrackingCollection extends PageCollection<
  OcorrenciaTracking
> {
  constructor() {
    super(OcorrenciaTracking)
  }

  queryAsPage() {
    return this.listOcorrenciaTracking()
  }

  async listOcorrenciaTracking() {
    return await Request.get(`/admin/ocorrencia-tracking`, {
      params: this.params,
    })
      .name('listOcorrenciaTracking')
      .as(this)
      .getResponse()
  }

  async listCsvOcorrenciaTracking() {
    return await Request.get(`/admin/ocorrencia-tracking/csv`, {
      params: this.params,
    })
      .name('listCsvOcorrenciaTracking')
      .as(this)
      .getResponse()
  }
}
